export default __webpack_public_path__ + "static/media/PhoneIcon.3a84d721.svg";